import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/contact/contact.component').then(
        m => m.ContactComponent,
      ),
  },
];
